import React from 'react';
import PropTypes from 'prop-types';
import DOMPurify from 'dompurify';

const RichTextDisplay = ({ content }) => {
  const cleanString = DOMPurify.sanitize(content);
  const htmlContent = {
    __html: cleanString,
  };
  

  return (
    <div>
      {/* eslint-disable-next-line react/no-danger */}
      <div dangerouslySetInnerHTML={htmlContent} />
    </div>
  );
};

RichTextDisplay.propTypes = {
  content: PropTypes.string.isRequired,
};

export default RichTextDisplay;
